import React, { useEffect, useState } from 'react';
import './Notification.css';

type NotificationProps = {
    message: string;
    type?: 'success' | 'error' | 'info';
};

export default function Notification({ message, type = 'info' }: NotificationProps) {
    const [visible, setVisible] = useState(false);
    const [progress, setProgress] = useState(100);

    useEffect(() => {
        if (!message) {
            setVisible(false);
            return;
        }
        setVisible(true);
        setProgress(100);
        const start = Date.now();
        const duration = 5000;

        const interval = setInterval(() => {
            const elapsed = Date.now() - start;
            const newProgress = Math.max(100 - (elapsed / duration) * 100, 0);
            setProgress(newProgress);
            if (elapsed >= duration) {
                setVisible(false);
                clearInterval(interval);
            }
        }, 50);

        return () => clearInterval(interval);
    }, [message]);

    if (!visible) return null;

    return (
        <div className={`notification ${type}`} role={type === 'error' ? 'alert' : 'status'}>
            {message}
            <div className="progress-bar" style={{ width: `${progress}%` }} />
        </div>
    );
}